/**
 * Formats a count against a bin's par level for side-by-side display with the
 * fullness ordinal. Count and par are shown honestly and are never merged with
 * fullness.
 *
 * - count null            → "—"            (no count parsed)
 * - par null or 0         → "N"            (raw count; no ratio, no divide-by-zero)
 * - otherwise             → "N / PAR — XX%" (ratio may exceed 100% for overstock)
 */
export function formatCountPar(count: number | null, parLevel: number | null): string {
  if (count == null) return '—';
  if (parLevel == null || parLevel === 0) return `${count}`;
  return `${count} / ${parLevel} — ${Math.round((count / parLevel) * 100)}%`;
}
